import { defineStore } from 'pinia'
import { AnnStore } from '@/front/stores/ann_store.js'
import { preloadManager } from '@/front/services/PreloadManager.js'

export const ClipStore = defineStore('clip', {
  state: () => {
    return {
      player: null,
      currentTime: 0,
      aspectRatio: null,
      playerState: {},
      requestedAt: null,
      startedAt: null,
      src: null,
      clipId: null,
      streamRequestId: 0,
      isLoading: false,
      error: null,
    }
  },

  actions: {
    setPlayerState(state) {
      this.playerState = state
      this.aspectRatio = state.width / state.height
      // log.info(3,"🔎 ClipStore setPlayerState", this.aspectRatio)
    },
    setSrc(src) {
      this.src = src
    },
    togglePlay() {
      this.playerState.playing ? this.player.pause() : this.player.play()
    },
    seekToPercentage(percentage) {
      log.info(2,"seekToPercentage", percentage)
      this.playerStore.seek((percentage / 100) * this.playerState.duration)
    },
    clear() {
      this.streamRequestId += 1
      this.src = null
      this.clipId = null
      this.playerState = {}
      this.isLoading = false
      this.error = null
    },
    async streamById(id) {
      this.clear()
      log.info(2,"🌜 ClipStore streamById", id)
      this.requestedAt = Date.now()
      this.clipId = id
      this.isLoading = true
      const requestId = this.streamRequestId

      const applySrc = (url, source = "api") => {
        if (requestId != this.streamRequestId) {
          log.info(2,"🟡 ClipStore ignored stale stream response", id, source)
          return null
        }
        if (!url) {
          throw new Error(`No clip URL returned for source ${id}`)
        }
        this.src = url
        this.error = null
        this.isLoading = false
        return url
      }

      // Check preload cache first
      const preloaded = preloadManager.getPreloadedClip(id)
      if (preloaded && preloaded.type === 'video') {
        log.info(2,"🔊 ClipStore using preloaded video", id)
        const url = applySrc(preloaded.url, "preload")
        return Promise.resolve(url)
      }

      // Fallback to regular loading
      return this.Api.get(`/assets/stream/${id}`).then(response => {
        const url = response?.data?.url
        log.info(2,"🔊 ClipStore streamById response", response.data)
        return applySrc(url, "api")
      }).catch((error) => {
        if (requestId == this.streamRequestId) {
          this.error = error?.message || "Failed to load clip"
          this.isLoading = false
        }
        throw error
      })
    }
  },
  getters: {
    progress: (state) => Math.round((state.currentTime / state.playerState.duration) * 100),
  }
})
